import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'REVIEW_OBSERVATION_MODAL';

/**
 * @deprecated Use ObservationEditorModal instead
 */
export const {action: show} = createAction(
    `${domain}/SHOW`,
    (observationId, refetchQueries, hideOnUpdate, successData, hideDrilldownLink) => ({
        observationId,
        refetchQueries,
        hideOnUpdate,
        successData,
        hideDrilldownLink,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: hideOnSuccess} = createAction(`${domain}/HIDE_ON_SUCCESS`, successData => ({successData}));

export const {
    action: comment,
    success: commentSuccess,
    failed: commentFailed,
} = createAction(
    `${domain}/COMMENT`,
    (originatorId, body) => ({originatorId, body}),
    (originatorId, comment) => ({originatorId, comment}),
    ({error, originatorId}) => ({error, originatorId}),
);

export const {
    action: deleteComment,
    success: deleteCommentSuccess,
    failed: deleteCommentFailed,
} = createAction(`${domain}/DELETE_COMMENT`, (originatorId, commentId) => ({originatorId, commentId}));

export const {action: setMobileActivityVisibility} = createAction(`${domain}/SET_MOBILE_ACTIVITY_VISIBILITY`, show => ({
    show,
}));

export const {action: didUpdate} = createAction(`${domain}/DID_UPDATE`, successData => ({successData}));
